import * as Types from '../../generated/types';

import gql from 'graphql-tag';
export type IOmiUserFragment = { __typename: 'User', id: string, firstName: string, lastName: string };

export type IOmiCustomerFragment = { __typename: 'Customer', id: string, sheetsTier: Types.ISheetsCustomerTier };

export type IOmiCustomerTierSettingsFragment = { __typename: 'SheetsTierSettings', maxUsers: number, maxContracts: number, cashFlowEnabled: boolean, accountIntegrationEnabled: boolean, exportEnabled: boolean, tierQuotaUsage: { __typename?: 'SheetsTierQuotaUsage', users: number, contracts: number } };

export const OmiUserFragmentDoc = gql`
    fragment OmiUser on User {
  __typename
  id
  firstName
  lastName
}
    `;
export const OmiCustomerFragmentDoc = gql`
    fragment OmiCustomer on Customer {
  __typename
  id
  sheetsTier
}
    `;
export const OmiCustomerTierSettingsFragmentDoc = gql`
    fragment OmiCustomerTierSettings on SheetsTierSettings {
  __typename
  maxUsers
  maxContracts
  cashFlowEnabled
  accountIntegrationEnabled
  exportEnabled
  tierQuotaUsage {
    users
    contracts
  }
}
    `;